import { forwardRef, useState } from "react";
import Typography from "../Typography/Typography";
import StyledButton from "./Button.styles";
import { ButtonOnClickType, ButtonProps } from "./Button.types";

const Button = forwardRef<HTMLButtonElement, ButtonProps>(
    (props: ButtonProps, ref) => {
        const {
            children,
            fillType = "contained",
            color = "primary",
            disableColor,
            disabled: _disabled = false,
            onClick,
            startIcon,
            endIcon,
            size = "m",
            mSize,
            ...restProps
        } = props;

        const [isExecuting, setIsExecuting] = useState(false);
        const disable = _disabled || isExecuting;

        const _onClick: ButtonOnClickType = async (e) => {
            setIsExecuting(true);
            try {
                await onClick?.(e);
            } finally {
                setIsExecuting(false);
            }
        };

        return (
            <StyledButton
                {...restProps}
                ref={ref}
                color={disable && disableColor ? disableColor : color}
                fillType={fillType}
                disabled={disable}
                onClick={_onClick}
                size={size}
            >
                {startIcon}
                <Typography size={size} mSize={mSize} weight="medium">
                    {children}
                </Typography>
                {endIcon}
            </StyledButton>
        );
    },
);

export default Button;
